import { useSyncExternalStore } from "react";

import { getOrgId, getOrganizations, subscribeOrgChange } from "lib/config";

// Reactive views of the org state. Re-render on setOrgId / addOrganization /
// clearOrgId (this tab) and on the `storage` event (other tabs).
export const useOrgId = (): string | null =>
    useSyncExternalStore(subscribeOrgChange, getOrgId);

export const useOrganizations = (): string[] =>
    useSyncExternalStore(subscribeOrgChange, getOrganizations);
